import React from "react";
import Layout from "../component/Layout";
import "./Homepage.css";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  AreaChart,
  Area,
} from "recharts";

const monthlySalesData = [
  { name: "Jan", sales: 42000, orders: 120 },
  { name: "Feb", sales: 38000, orders: 98 },
  { name: "Mar", sales: 51000, orders: 140 },
  { name: "Apr", sales: 45000, orders: 110 },
  { name: "May", sales: 60000, orders: 160 },
];

const customerData = [
  { name: "Returning", value: 400 },
  { name: "New", value: 300 },
  { name: "Guest", value: 200 },
];

const COLORS = ["#8a6b32", "#d4af37", "#c0c0c0"];

const Homepage = () => {
  return (
    <Layout pageTitle="Operator Dashboard">

      {/* Top Stat Cards */}
      <div className="stats-grid">
        {[
          { title: "Revenue", value: "₹20,53,500", change: "+12%" },
          { title: "Orders", value: "628", change: "+8%" },
          { title: "Customers", value: "1,240", change: "+15%" },
          { title: "Growth", value: "18%", change: "↑ steady" },
        ].map((stat, index) => (
          <div key={index} className="stat-card">
            <h4>{stat.title}</h4>
            <h2>{stat.value}</h2>
            <p>{stat.change}</p>
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <div className="charts-section">
        {/* Line Chart */}
        <div className="chart-container">
          <h3>Monthly Revenue Trend</h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={monthlySalesData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="sales" stroke="#8a6b32" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Bar Chart */}
        <div className="chart-container">
          <h3>Monthly Orders</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={monthlySalesData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="orders" fill="#d4af37" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bottom-charts">
        {/* Pie Chart */}
        <div className="chart-container">
          <h3>Customer Breakdown</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={customerData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                dataKey="value"
              >
                {customerData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Area Chart */}
        <div className="chart-container">
          <h3>Sales Growth Over Time</h3>
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={monthlySalesData}>
              <defs>
                <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#8a6b32" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#8a6b32" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Area type="monotone" dataKey="sales" stroke="#8a6b32" fillOpacity={1} fill="url(#colorSales)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Layout>
  );
};

export default Homepage;